// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global Theme CSS Variables
 * 
 * These CSS variables are set by ThemeManager and can be used
 * throughout the application. Default values are provided as fallbacks.
 */

:root {
  /* Core UI colors - defaults to classic-dark */
  --bg: #0a0a0f;
  --table: linear-gradient(180deg, #0a0a0f 0%, #1a1a2e 30%, #0f1419 70%, #050508 100%);
  --text: #ffffff;
  --accent: #667eea;
  
  /* Card colors - defaults to classic-dark */
  --card-red: #E53935;
  --card-yellow: #FDD835;
  --card-green: #43A047;
  --card-blue: #1E88E5;
  
  /* Optional effects */
  --glow: #667eea;
  
  /* Semantic color mappings for card colors */
  --color-red: var(--card-red);
  --color-yellow: var(--card-yellow);
  --color-green: var(--card-green);
  --color-blue: var(--card-blue);
  
  /* Common UI element colors derived from theme */
  --bg-overlay: rgba(0, 0, 0, 0.7);
  --bg-card: rgba(30, 30, 50, 0.95);
  --bg-card-hover: rgba(40, 40, 60, 0.8);
  --border-subtle: rgba(255, 255, 255, 0.1);
  --border-medium: rgba(255, 255, 255, 0.2);
  --text-muted: rgba(255, 255, 255, 0.7);
}

/* Casual Party theme-specific semantic mappings */
:root[data-theme="casual-party"] {
  /* Background overlays - solid colors, NO blur, readable on cream */
  --bg-overlay: rgba(44, 36, 22, 0.85);
  --bg-card: #fffcf7; /* Solid warm cream (no transparency/blur) */
  --bg-card-hover: #f5f0e8; /* Slightly darker on hover */
  
  /* Borders - subtle on cream, clear definition */
  --border-subtle: rgba(44, 36, 22, 0.15);
  --border-medium: rgba(44, 36, 22, 0.3); /* Increased contrast for better visibility */
  
  /* Text - high contrast, WCAG AA compliant */
  --text-muted: rgba(44, 36, 22, 0.7); /* Increased from 0.65 for better readability */
  
  /* Button colors - consistent semantic mapping */
  --btn-primary: var(--accent);
  --btn-primary-hover: color-mix(in srgb, var(--accent) 90%, white);
  --btn-danger: var(--card-red);
  --btn-success: var(--card-green);
  
  /* Penalty card colors - muted to match card colors */
  --penalty-draw2: var(--card-blue);
  --penalty-draw4: #d85a5a;
  
  /* UNO button colors - readable on cream background */
  --uno-active: #ffd93d;
  --uno-active-text: #2c2416;
  --uno-inactive: var(--card-red);
  --uno-urgent: var(--card-red);
  
  /* Disabled state - lower saturation, slight opacity, NO blur */
  --disabled-opacity: 0.5; /* Increased from 0.4 for better visibility */
  --disabled-saturation: grayscale(40%); /* Reduced from 60% - less aggressive */
  
  /* Indicator colors - readable on cream */
  --indicator-accent: var(--accent);
  --warning-bg: rgba(255, 193, 7, 0.9);
  --warning-text: #6d4e00;
  
  /* Effect tokens - Casual Party specific */
  --card-play-animation: bounce;
  --card-hover-scale: 1.05;
  --card-play-duration: 240ms;
  --turn-indicator-style: bounce-highlight;
  --glow-intensity: 0.3; /* Reduced from 1.0 - 70% reduction */
  --penalty-animation: bounce;
}

/* Utility classes for common patterns */
.theme-bg {
  background: var(--bg);
}

.theme-table {
  background: var(--table);
}

.theme-text {
  color: var(--text);
}

.theme-accent {
  color: var(--accent);
}

/* Card color utilities */
.card-red {
  color: var(--card-red);
  background-color: var(--card-red);
}

.card-yellow {
  color: var(--card-yellow);
  background-color: var(--card-yellow);
}

.card-green {
  color: var(--card-green);
  background-color: var(--card-green);
}

.card-blue {
  color: var(--card-blue);
  background-color: var(--card-blue);
}

/* Disabled card styling */
.card-disabled {
  opacity: var(--disabled-opacity);
  filter: var(--disabled-saturation);
}

/* ============================================
   ANIMATION ABSTRACTION LAYER
   ============================================
   Semantic classes that read behavior from effect tokens.
   Components only toggle classes, never animation names.
   ============================================ */

/* Card Hover Effect - Desktop */
.card-hover {
  transition: transform var(--card-play-duration, 180ms) cubic-bezier(0.25, 0.46, 0.45, 0.94),
              box-shadow var(--card-play-duration, 180ms) ease-out;
}

/* Scale only - framer-motion handles Y translation */
/* Note: We use a wrapper approach - scale is applied via CSS, Y via framer-motion */
.card-hover:hover:not(.card-disabled) {
  /* Scale is applied, but framer-motion's Y will combine with it */
  transform: scale(var(--card-hover-scale, 1.03));
}

/* Card Tap Effect - Mobile */
.card-tap {
  transition: transform 0.12s ease-out;
}

.card-tap:active:not(.card-disabled) {
  transform: scale(0.96);
}

/* Card Play Animation - Theme-specific */
.card-play {
  animation-duration: var(--card-play-duration, 180ms);
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation-fill-mode: both;
}

/* Slide animation (classic-dark) */
:root[data-theme="classic-dark"] .card-play,
[data-theme="classic-dark"] .card-play,
.card-play[data-animation="slide"] {
  animation-name: card-play-slide;
}

@keyframes card-play-slide {
  0% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  50% {
    transform: scale(1.05) translateY(-8px);
    opacity: 0.95;
  }
  100% {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
  }
}

/* Glow Pulse animation (neon-arena) */
:root[data-theme="neon-arena"] .card-play,
[data-theme="neon-arena"] .card-play,
.card-play[data-animation="glow-pulse"] {
  animation-name: card-play-glow-pulse;
}

@keyframes card-play-glow-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
    filter: drop-shadow(0 0 0 var(--glow));
  }
  30% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 20px var(--glow)) drop-shadow(0 0 40px var(--glow));
  }
  60% {
    transform: scale(1.05);
    filter: drop-shadow(0 0 30px var(--glow));
  }
  100% {
    transform: scale(0.85);
    opacity: 0;
    filter: drop-shadow(0 0 0 var(--glow));
  }
}

/* Bounce animation (casual-party) - ease-out + small bounce */
:root[data-theme="casual-party"] .card-play,
[data-theme="casual-party"] .card-play,
.card-play[data-animation="bounce"] {
  animation-name: card-play-bounce;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94); /* ease-out */
}

@keyframes card-play-bounce {
  0% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  30% {
    transform: scale(1.1) translateY(-12px); /* Small bounce up */
  }
  60% {
    transform: scale(0.98) translateY(8px); /* Small bounce down */
  }
  85% {
    transform: scale(0.95) translateY(15px); /* Settle */
  }
  100% {
    transform: scale(0.85) translateY(25px); /* Final position */
    opacity: 0;
  }
}

/* Turn Indicator Styles */
.turn-indicator {
  position: relative;
}

.turn-indicator-glow {
  /* Fallback glow animation if CSS animations don't apply */
  animation: turn-indicator-glow-fallback 2s ease-in-out infinite;
}

@keyframes turn-indicator-glow-fallback {
  0%, 100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}

/* Glow Soft (classic-dark) */
:root[data-theme="classic-dark"] .turn-indicator-active,
[data-theme="classic-dark"] .turn-indicator-active,
.turn-indicator-active[data-style="glow-soft"] {
  animation: turn-indicator-glow-soft 2s ease-in-out infinite;
}

@keyframes turn-indicator-glow-soft {
  0%, 100% {
    box-shadow: 0 0 15px rgba(102, 126, 234, 0.4),
                0 0 30px rgba(102, 126, 234, 0.2),
                0 4px 12px rgba(0, 0, 0, 0.3);
  }
  50% {
    box-shadow: 0 0 25px rgba(102, 126, 234, 0.6),
                0 0 50px rgba(102, 126, 234, 0.3),
                0 4px 12px rgba(0, 0, 0, 0.3);
  }
}

/* Neon Ring (neon-arena) */
:root[data-theme="neon-arena"] .turn-indicator-active,
[data-theme="neon-arena"] .turn-indicator-active,
.turn-indicator-active[data-style="neon-ring"] {
  animation: turn-indicator-neon-ring 1.5s ease-in-out infinite;
}

@keyframes turn-indicator-neon-ring {
  0%, 100% {
    box-shadow: 0 0 10px var(--glow),
                0 0 20px var(--glow),
                0 0 30px var(--glow),
                0 0 40px var(--glow),
                inset 0 0 20px var(--glow);
    border-color: var(--glow);
  }
  50% {
    box-shadow: 0 0 20px var(--glow),
                0 0 40px var(--glow),
                0 0 60px var(--glow),
                0 0 80px var(--glow),
                inset 0 0 30px var(--glow);
    border-color: var(--accent);
  }
}

/* Bounce Highlight (casual-party) */
:root[data-theme="casual-party"] .turn-indicator-active,
[data-theme="casual-party"] .turn-indicator-active,
.turn-indicator-active[data-style="bounce-highlight"] {
  animation: turn-indicator-bounce-highlight 1.2s ease-in-out infinite;
}

@keyframes turn-indicator-bounce-highlight {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 12px color-mix(in srgb, var(--accent) 40%, transparent);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 24px color-mix(in srgb, var(--accent) 60%, transparent),
                0 0 30px color-mix(in srgb, var(--accent) 30%, transparent);
  }
}

/* Penalty Effects */
.penalty-effect {
  animation-duration: 0.3s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

/* Pulse (classic-dark) */
:root[data-theme="classic-dark"] .penalty-effect,
[data-theme="classic-dark"] .penalty-effect,
.penalty-effect[data-animation="pulse"] {
  animation-name: penalty-pulse;
}

@keyframes penalty-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Neon Flash (neon-arena) */
:root[data-theme="neon-arena"] .penalty-effect,
[data-theme="neon-arena"] .penalty-effect,
.penalty-effect[data-animation="neon-flash"] {
  animation-name: penalty-neon-flash;
}

@keyframes penalty-neon-flash {
  0%, 100% {
    filter: drop-shadow(0 0 5px var(--glow));
    transform: scale(1);
  }
  25% {
    filter: drop-shadow(0 0 20px var(--glow)) 
            drop-shadow(0 0 40px var(--glow))
            drop-shadow(0 0 60px var(--glow));
    transform: scale(1.1);
  }
  50% {
    filter: drop-shadow(0 0 10px var(--glow));
    transform: scale(1.05);
  }
  75% {
    filter: drop-shadow(0 0 25px var(--glow))
            drop-shadow(0 0 50px var(--glow));
    transform: scale(1.08);
  }
}

/* Bounce (casual-party) */
:root[data-theme="casual-party"] .penalty-effect,
[data-theme="casual-party"] .penalty-effect,
.penalty-effect[data-animation="bounce"] {
  animation-name: penalty-bounce;
}

@keyframes penalty-bounce {
  0%, 100% {
    transform: scale(1) translateY(0);
  }
  25% {
    transform: scale(1.2) translateY(-10px);
  }
  50% {
    transform: scale(1.1) translateY(-5px);
  }
  75% {
    transform: scale(1.15) translateY(-8px);
  }
}

/* ============================================
   REDUCED MOTION SUPPORT
   ============================================ */

@media (prefers-reduced-motion: reduce) {
  /* Reduce animation durations */
  .card-play,
  .penalty-effect {
    animation-duration: 0.1s !important;
  }
  
  .turn-indicator-active {
    animation-duration: 1s !important;
  }
  
  /* Replace movement with opacity/scale only */
  .card-play {
    animation-name: card-play-reduced !important;
  }
  
  @keyframes card-play-reduced {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(0.9);
    }
  }
  
  /* Reduce glow intensity */
  .turn-indicator-active {
    animation-name: turn-indicator-reduced !important;
  }
  
  @keyframes turn-indicator-reduced {
    0%, 100% {
      opacity: 0.8;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
    50% {
      opacity: 1;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }
  }
  
  /* Reduce bounce amplitude */
  .penalty-effect {
    animation-name: penalty-reduced !important;
  }
  
  @keyframes penalty-reduced {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.9;
      transform: scale(1.05);
    }
  }
  
  /* Disable hover transforms */
  .card-hover:hover:not(.card-disabled) {
    transform: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/themes/global.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,8CAA8C;EAC9C,aAAa;EACb,oFAAoF;EACpF,eAAe;EACf,iBAAiB;;EAEjB,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;;EAEpB,qBAAqB;EACrB,eAAe;;EAEf,4CAA4C;EAC5C,4BAA4B;EAC5B,kCAAkC;EAClC,gCAAgC;EAChC,8BAA8B;;EAE9B,gDAAgD;EAChD,gCAAgC;EAChC,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;EACzC,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA,kDAAkD;AAClD;EACE,mEAAmE;EACnE,oCAAoC;EACpC,kBAAkB,EAAE,4CAA4C;EAChE,wBAAwB,EAAE,6BAA6B;;EAEvD,gDAAgD;EAChD,uCAAuC;EACvC,sCAAsC,EAAE,6CAA6C;;EAErF,4CAA4C;EAC5C,mCAAmC,EAAE,+CAA+C;;EAEpF,gDAAgD;EAChD,4BAA4B;EAC5B,iEAAiE;EACjE,6BAA6B;EAC7B,gCAAgC;;EAEhC,qDAAqD;EACrD,iCAAiC;EACjC,wBAAwB;;EAExB,qDAAqD;EACrD,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,6BAA6B;;EAE7B,+DAA+D;EAC/D,uBAAuB,EAAE,6CAA6C;EACtE,qCAAqC,EAAE,uCAAuC;;EAE9E,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;EACpC,uBAAuB;;EAEvB,0CAA0C;EAC1C,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB,EAAE,qCAAqC;EAC5D,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;;;;iDAKiD;;AAEjD,gCAAgC;AAChC;EACE;kEACgE;AAClE;;AAEA,qDAAqD;AACrD,oFAAoF;AACpF;EACE,iEAAiE;EACjE,+CAA+C;AACjD;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,oDAAoD;EACpD,+DAA+D;EAC/D,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;;EAGE,+BAA+B;AACjC;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,aAAa;EACf;EACA;IACE,sCAAsC;IACtC,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;;;EAGE,oCAAoC;AACtC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,qBAAqB;IACrB,2EAA2E;EAC7E;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;EACA;IACE,sBAAsB;IACtB,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,8DAA8D;AAC9D;;;EAGE,gCAAgC;EAChC,+DAA+D,EAAE,aAAa;AAChF;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,uCAAuC,EAAE,oBAAoB;EAC/D;EACA;IACE,sCAAsC,EAAE,sBAAsB;EAChE;EACA;IACE,uCAAuC,EAAE,WAAW;EACtD;EACA;IACE,uCAAuC,EAAE,mBAAmB;IAC5D,UAAU;EACZ;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,+DAA+D;AACjE;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,6BAA6B;AAC7B;;;EAGE,2DAA2D;AAC7D;;AAEA;EACE;IACE;;6CAEyC;EAC3C;EACA;IACE;;6CAEyC;EAC3C;AACF;;AAEA,2BAA2B;AAC3B;;;EAGE,6DAA6D;AAC/D;;AAEA;EACE;IACE;;;;0CAIsC;IACtC,yBAAyB;EAC3B;EACA;IACE;;;;0CAIsC;IACtC,2BAA2B;EAC7B;AACF;;AAEA,oCAAoC;AACpC;;;EAGE,oEAAoE;AACtE;;AAEA;EACE;IACE,mBAAmB;IACnB,yEAAyE;EAC3E;EACA;IACE,sBAAsB;IACtB;2EACuE;EACzE;AACF;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,kCAAkC;AACpC;;AAEA;EACE;IACE,wCAAwC;IACxC,mBAAmB;EACrB;EACA;IACE;;6CAEyC;IACzC,qBAAqB;EACvB;EACA;IACE,yCAAyC;IACzC,sBAAsB;EACxB;EACA;IACE;6CACyC;IACzC,sBAAsB;EACxB;AACF;;AAEA,0BAA0B;AAC1B;;;EAGE,8BAA8B;AAChC;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,+BAA+B;EAC/B;;IAEE,mCAAmC;EACrC;;EAEA;IACE,iCAAiC;EACnC;;EAEA,6CAA6C;EAC7C;IACE,4CAA4C;EAC9C;;EAEA;IACE;MACE,UAAU;MACV,mBAAmB;IACrB;IACA;MACE,UAAU;MACV,qBAAqB;IACvB;EACF;;EAEA,0BAA0B;EAC1B;IACE,iDAAiD;EACnD;;EAEA;IACE;MACE,YAAY;MACZ,wCAAwC;IAC1C;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;EACF;;EAEA,4BAA4B;EAC5B;IACE,0CAA0C;EAC5C;;EAEA;IACE;MACE,UAAU;MACV,mBAAmB;IACrB;IACA;MACE,YAAY;MACZ,sBAAsB;IACxB;EACF;;EAEA,6BAA6B;EAC7B;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * Global Theme CSS Variables\n * \n * These CSS variables are set by ThemeManager and can be used\n * throughout the application. Default values are provided as fallbacks.\n */\n\n:root {\n  /* Core UI colors - defaults to classic-dark */\n  --bg: #0a0a0f;\n  --table: linear-gradient(180deg, #0a0a0f 0%, #1a1a2e 30%, #0f1419 70%, #050508 100%);\n  --text: #ffffff;\n  --accent: #667eea;\n  \n  /* Card colors - defaults to classic-dark */\n  --card-red: #E53935;\n  --card-yellow: #FDD835;\n  --card-green: #43A047;\n  --card-blue: #1E88E5;\n  \n  /* Optional effects */\n  --glow: #667eea;\n  \n  /* Semantic color mappings for card colors */\n  --color-red: var(--card-red);\n  --color-yellow: var(--card-yellow);\n  --color-green: var(--card-green);\n  --color-blue: var(--card-blue);\n  \n  /* Common UI element colors derived from theme */\n  --bg-overlay: rgba(0, 0, 0, 0.7);\n  --bg-card: rgba(30, 30, 50, 0.95);\n  --bg-card-hover: rgba(40, 40, 60, 0.8);\n  --border-subtle: rgba(255, 255, 255, 0.1);\n  --border-medium: rgba(255, 255, 255, 0.2);\n  --text-muted: rgba(255, 255, 255, 0.7);\n}\n\n/* Casual Party theme-specific semantic mappings */\n:root[data-theme=\"casual-party\"] {\n  /* Background overlays - solid colors, NO blur, readable on cream */\n  --bg-overlay: rgba(44, 36, 22, 0.85);\n  --bg-card: #fffcf7; /* Solid warm cream (no transparency/blur) */\n  --bg-card-hover: #f5f0e8; /* Slightly darker on hover */\n  \n  /* Borders - subtle on cream, clear definition */\n  --border-subtle: rgba(44, 36, 22, 0.15);\n  --border-medium: rgba(44, 36, 22, 0.3); /* Increased contrast for better visibility */\n  \n  /* Text - high contrast, WCAG AA compliant */\n  --text-muted: rgba(44, 36, 22, 0.7); /* Increased from 0.65 for better readability */\n  \n  /* Button colors - consistent semantic mapping */\n  --btn-primary: var(--accent);\n  --btn-primary-hover: color-mix(in srgb, var(--accent) 90%, white);\n  --btn-danger: var(--card-red);\n  --btn-success: var(--card-green);\n  \n  /* Penalty card colors - muted to match card colors */\n  --penalty-draw2: var(--card-blue);\n  --penalty-draw4: #d85a5a;\n  \n  /* UNO button colors - readable on cream background */\n  --uno-active: #ffd93d;\n  --uno-active-text: #2c2416;\n  --uno-inactive: var(--card-red);\n  --uno-urgent: var(--card-red);\n  \n  /* Disabled state - lower saturation, slight opacity, NO blur */\n  --disabled-opacity: 0.5; /* Increased from 0.4 for better visibility */\n  --disabled-saturation: grayscale(40%); /* Reduced from 60% - less aggressive */\n  \n  /* Indicator colors - readable on cream */\n  --indicator-accent: var(--accent);\n  --warning-bg: rgba(255, 193, 7, 0.9);\n  --warning-text: #6d4e00;\n  \n  /* Effect tokens - Casual Party specific */\n  --card-play-animation: bounce;\n  --card-hover-scale: 1.05;\n  --card-play-duration: 240ms;\n  --turn-indicator-style: bounce-highlight;\n  --glow-intensity: 0.3; /* Reduced from 1.0 - 70% reduction */\n  --penalty-animation: bounce;\n}\n\n/* Utility classes for common patterns */\n.theme-bg {\n  background: var(--bg);\n}\n\n.theme-table {\n  background: var(--table);\n}\n\n.theme-text {\n  color: var(--text);\n}\n\n.theme-accent {\n  color: var(--accent);\n}\n\n/* Card color utilities */\n.card-red {\n  color: var(--card-red);\n  background-color: var(--card-red);\n}\n\n.card-yellow {\n  color: var(--card-yellow);\n  background-color: var(--card-yellow);\n}\n\n.card-green {\n  color: var(--card-green);\n  background-color: var(--card-green);\n}\n\n.card-blue {\n  color: var(--card-blue);\n  background-color: var(--card-blue);\n}\n\n/* Disabled card styling */\n.card-disabled {\n  opacity: var(--disabled-opacity);\n  filter: var(--disabled-saturation);\n}\n\n/* ============================================\n   ANIMATION ABSTRACTION LAYER\n   ============================================\n   Semantic classes that read behavior from effect tokens.\n   Components only toggle classes, never animation names.\n   ============================================ */\n\n/* Card Hover Effect - Desktop */\n.card-hover {\n  transition: transform var(--card-play-duration, 180ms) cubic-bezier(0.25, 0.46, 0.45, 0.94),\n              box-shadow var(--card-play-duration, 180ms) ease-out;\n}\n\n/* Scale only - framer-motion handles Y translation */\n/* Note: We use a wrapper approach - scale is applied via CSS, Y via framer-motion */\n.card-hover:hover:not(.card-disabled) {\n  /* Scale is applied, but framer-motion's Y will combine with it */\n  transform: scale(var(--card-hover-scale, 1.03));\n}\n\n/* Card Tap Effect - Mobile */\n.card-tap {\n  transition: transform 0.12s ease-out;\n}\n\n.card-tap:active:not(.card-disabled) {\n  transform: scale(0.96);\n}\n\n/* Card Play Animation - Theme-specific */\n.card-play {\n  animation-duration: var(--card-play-duration, 180ms);\n  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  animation-fill-mode: both;\n}\n\n/* Slide animation (classic-dark) */\n:root[data-theme=\"classic-dark\"] .card-play,\n[data-theme=\"classic-dark\"] .card-play,\n.card-play[data-animation=\"slide\"] {\n  animation-name: card-play-slide;\n}\n\n@keyframes card-play-slide {\n  0% {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05) translateY(-8px);\n    opacity: 0.95;\n  }\n  100% {\n    transform: scale(0.9) translateY(20px);\n    opacity: 0;\n  }\n}\n\n/* Glow Pulse animation (neon-arena) */\n:root[data-theme=\"neon-arena\"] .card-play,\n[data-theme=\"neon-arena\"] .card-play,\n.card-play[data-animation=\"glow-pulse\"] {\n  animation-name: card-play-glow-pulse;\n}\n\n@keyframes card-play-glow-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n    filter: drop-shadow(0 0 0 var(--glow));\n  }\n  30% {\n    transform: scale(1.1);\n    filter: drop-shadow(0 0 20px var(--glow)) drop-shadow(0 0 40px var(--glow));\n  }\n  60% {\n    transform: scale(1.05);\n    filter: drop-shadow(0 0 30px var(--glow));\n  }\n  100% {\n    transform: scale(0.85);\n    opacity: 0;\n    filter: drop-shadow(0 0 0 var(--glow));\n  }\n}\n\n/* Bounce animation (casual-party) - ease-out + small bounce */\n:root[data-theme=\"casual-party\"] .card-play,\n[data-theme=\"casual-party\"] .card-play,\n.card-play[data-animation=\"bounce\"] {\n  animation-name: card-play-bounce;\n  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94); /* ease-out */\n}\n\n@keyframes card-play-bounce {\n  0% {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n  30% {\n    transform: scale(1.1) translateY(-12px); /* Small bounce up */\n  }\n  60% {\n    transform: scale(0.98) translateY(8px); /* Small bounce down */\n  }\n  85% {\n    transform: scale(0.95) translateY(15px); /* Settle */\n  }\n  100% {\n    transform: scale(0.85) translateY(25px); /* Final position */\n    opacity: 0;\n  }\n}\n\n/* Turn Indicator Styles */\n.turn-indicator {\n  position: relative;\n}\n\n.turn-indicator-glow {\n  /* Fallback glow animation if CSS animations don't apply */\n  animation: turn-indicator-glow-fallback 2s ease-in-out infinite;\n}\n\n@keyframes turn-indicator-glow-fallback {\n  0%, 100% {\n    opacity: 0.4;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.1);\n  }\n}\n\n/* Glow Soft (classic-dark) */\n:root[data-theme=\"classic-dark\"] .turn-indicator-active,\n[data-theme=\"classic-dark\"] .turn-indicator-active,\n.turn-indicator-active[data-style=\"glow-soft\"] {\n  animation: turn-indicator-glow-soft 2s ease-in-out infinite;\n}\n\n@keyframes turn-indicator-glow-soft {\n  0%, 100% {\n    box-shadow: 0 0 15px rgba(102, 126, 234, 0.4),\n                0 0 30px rgba(102, 126, 234, 0.2),\n                0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 25px rgba(102, 126, 234, 0.6),\n                0 0 50px rgba(102, 126, 234, 0.3),\n                0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n}\n\n/* Neon Ring (neon-arena) */\n:root[data-theme=\"neon-arena\"] .turn-indicator-active,\n[data-theme=\"neon-arena\"] .turn-indicator-active,\n.turn-indicator-active[data-style=\"neon-ring\"] {\n  animation: turn-indicator-neon-ring 1.5s ease-in-out infinite;\n}\n\n@keyframes turn-indicator-neon-ring {\n  0%, 100% {\n    box-shadow: 0 0 10px var(--glow),\n                0 0 20px var(--glow),\n                0 0 30px var(--glow),\n                0 0 40px var(--glow),\n                inset 0 0 20px var(--glow);\n    border-color: var(--glow);\n  }\n  50% {\n    box-shadow: 0 0 20px var(--glow),\n                0 0 40px var(--glow),\n                0 0 60px var(--glow),\n                0 0 80px var(--glow),\n                inset 0 0 30px var(--glow);\n    border-color: var(--accent);\n  }\n}\n\n/* Bounce Highlight (casual-party) */\n:root[data-theme=\"casual-party\"] .turn-indicator-active,\n[data-theme=\"casual-party\"] .turn-indicator-active,\n.turn-indicator-active[data-style=\"bounce-highlight\"] {\n  animation: turn-indicator-bounce-highlight 1.2s ease-in-out infinite;\n}\n\n@keyframes turn-indicator-bounce-highlight {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 4px 12px color-mix(in srgb, var(--accent) 40%, transparent);\n  }\n  50% {\n    transform: scale(1.08);\n    box-shadow: 0 8px 24px color-mix(in srgb, var(--accent) 60%, transparent),\n                0 0 30px color-mix(in srgb, var(--accent) 30%, transparent);\n  }\n}\n\n/* Penalty Effects */\n.penalty-effect {\n  animation-duration: 0.3s;\n  animation-timing-function: ease-out;\n  animation-fill-mode: both;\n}\n\n/* Pulse (classic-dark) */\n:root[data-theme=\"classic-dark\"] .penalty-effect,\n[data-theme=\"classic-dark\"] .penalty-effect,\n.penalty-effect[data-animation=\"pulse\"] {\n  animation-name: penalty-pulse;\n}\n\n@keyframes penalty-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.15);\n    opacity: 0.9;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Neon Flash (neon-arena) */\n:root[data-theme=\"neon-arena\"] .penalty-effect,\n[data-theme=\"neon-arena\"] .penalty-effect,\n.penalty-effect[data-animation=\"neon-flash\"] {\n  animation-name: penalty-neon-flash;\n}\n\n@keyframes penalty-neon-flash {\n  0%, 100% {\n    filter: drop-shadow(0 0 5px var(--glow));\n    transform: scale(1);\n  }\n  25% {\n    filter: drop-shadow(0 0 20px var(--glow)) \n            drop-shadow(0 0 40px var(--glow))\n            drop-shadow(0 0 60px var(--glow));\n    transform: scale(1.1);\n  }\n  50% {\n    filter: drop-shadow(0 0 10px var(--glow));\n    transform: scale(1.05);\n  }\n  75% {\n    filter: drop-shadow(0 0 25px var(--glow))\n            drop-shadow(0 0 50px var(--glow));\n    transform: scale(1.08);\n  }\n}\n\n/* Bounce (casual-party) */\n:root[data-theme=\"casual-party\"] .penalty-effect,\n[data-theme=\"casual-party\"] .penalty-effect,\n.penalty-effect[data-animation=\"bounce\"] {\n  animation-name: penalty-bounce;\n}\n\n@keyframes penalty-bounce {\n  0%, 100% {\n    transform: scale(1) translateY(0);\n  }\n  25% {\n    transform: scale(1.2) translateY(-10px);\n  }\n  50% {\n    transform: scale(1.1) translateY(-5px);\n  }\n  75% {\n    transform: scale(1.15) translateY(-8px);\n  }\n}\n\n/* ============================================\n   REDUCED MOTION SUPPORT\n   ============================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  /* Reduce animation durations */\n  .card-play,\n  .penalty-effect {\n    animation-duration: 0.1s !important;\n  }\n  \n  .turn-indicator-active {\n    animation-duration: 1s !important;\n  }\n  \n  /* Replace movement with opacity/scale only */\n  .card-play {\n    animation-name: card-play-reduced !important;\n  }\n  \n  @keyframes card-play-reduced {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    100% {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n  }\n  \n  /* Reduce glow intensity */\n  .turn-indicator-active {\n    animation-name: turn-indicator-reduced !important;\n  }\n  \n  @keyframes turn-indicator-reduced {\n    0%, 100% {\n      opacity: 0.8;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    }\n    50% {\n      opacity: 1;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n    }\n  }\n  \n  /* Reduce bounce amplitude */\n  .penalty-effect {\n    animation-name: penalty-reduced !important;\n  }\n  \n  @keyframes penalty-reduced {\n    0%, 100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.9;\n      transform: scale(1.05);\n    }\n  }\n  \n  /* Disable hover transforms */\n  .card-hover:hover:not(.card-disabled) {\n    transform: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
